
import autobind from 'autobind-decorator';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';

import * as CommonAuthService from '../../../../common/services/auth';
import { ConfigProp, RenderPropWithProps, RouteProps, TranslationFuncProp } from '../../../../common/types/prop-types/common';
import { RootState } from '../../../base';
import { config } from '../../../common';
import { AppThunkDispatch } from '../../../common/types';

export interface LandingProps extends ConfigProp {
    onLogout: (event: React.MouseEvent<{}> | null) => void;
}

export interface LandingContainerProps {}

interface ReduxStateProps {
}

interface ReduxDispatchProps {
    authServiceActions: CommonAuthService.Service.ServiceActions;
}

class LandingContainer extends Component<
    LandingContainerProps &
    TranslationFuncProp &
    RouteProps &
    RenderPropWithProps<LandingProps> &
    ReduxStateProps &
    ReduxDispatchProps
> {
    public static propTypes = {
        t: PropTypes.func.isRequired,
        routeProps: PropTypes.any.isRequired,
        authServiceActions: CommonAuthService.Service.ServiceActionPropTypes,
        //
        children: PropTypes.func.isRequired,
    };

    @autobind
    public async onLogout(e: React.MouseEvent<{}> | null) {
        if (e) {
            e.preventDefault();
        }
        this.props.authServiceActions.logout();
        this.props.routeProps.history.push(`${config.BaseURL}/logout`);
    }

    @autobind
    public isReadyToRender(): boolean {
        return true;
    }

    public canNavToExampleModule(): boolean {
        return true;
    }

    public render() {
        const newProps: LandingProps = {
            onLogout: this.onLogout,
            config,
        };

        return this.props.children(newProps);
    }
}

const mapStateToProps = (store: RootState) => ({
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    authServiceActions: CommonAuthService.Service.bindServiceActionCreators(config, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LandingContainer);
